<template>
  <div class="app-container">
    <div class="activity-list-filter">
      <el-row>
         <el-col :span="6">
          <div class="grid-content">
            <el-select class="activity-list-filter-value" placeholder="所属区域" v-model="filter.regionName" size="small">
               <el-option
                v-for="item in areaOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content">
            <el-select class="activity-list-filter-value" placeholder="所属市场" v-model="filter.marketId" size="small">
               <el-option
                v-for="item in marketOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content">
            <el-select class="activity-list-filter-value" placeholder="树木当前阶段" v-model="filter.status" size="small">
               <el-option
                v-for="item in DreamTreeStatusEnum"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
        </el-col>
        <el-col :span="6">
          <div>
            <el-button class="activity-list-filter-search" size="small" @click="loadData(true)">立即筛选</el-button>
            <el-button class="activity-list-filter-reset" size="small" @click="resetFilter">清除条件</el-button>
          </div>
        </el-col>
      </el-row>
    </div>
    <basic-container>
      <avue-crud
        :page="pageItem"
        :data="displayData"
        @current-change="pageItem.currentPage=$event;loadData()"
        @size-change="pageItem.pageSize=$event;loadData(true)"
        :option="treeListOption"
        :table-loading="loading">
      </avue-crud>
    </basic-container>
  </div>
</template>

<script>

import { treeListOption } from '@/const/crud/activity/tree';
import { fetchDreamTreeList, fetchMarketOptions, fetchRegionOptions } from '@/api/activity/activity';
import DreamTreeStatusEnum from '@/common/enums/DreamTreeStatusEnum';


export default {
  data() {
    return {
      treeListOption,
      DreamTreeStatusEnum,
      data: [],
      marketOptions: [],
      areaOptions: [],
      pageItem: {
        total: 0,
        currentPage: 1,
        pageSize: 10,
      },
      loading: false,
      filter: {
        marketId: '',
        regionName: '',
        status: '',
      },
    }
  },
  created() {
    this.loadMarketOptions();
    this.loadAreaOptions();
    this.loadData(true);
  },
  computed: {
    displayData() {
      const data = JSON.parse(JSON.stringify(this.data));
      data.forEach(item => {
        item['plantingPercent'] = (item['plantingPercent'] * 100).toFixed(2) + "%";
        item['status'] = this.DreamTreeStatusEnum[item['status']].label;
      });
      return data;
    }
  },
  methods: {
    loadData(init) {
      this.loading = true;
      this.pageItem.currentPage = init ? 1 : this.pageItem.currentPage;
      const page = {
        current: this.pageItem.currentPage,
        size: this.pageItem.pageSize,
      };
      const filter = Object.assign(JSON.parse(JSON.stringify(this.filter)), page);
      fetchDreamTreeList(filter).then(response => {
        if (response.data && response.data.code === 0 && response.data.data) {
          this.data = response.data.data.records;
          this.pageItem.total = response.data.data.total;
        }
        this.loading = false;
      });
    },
    loadAreaOptions() {
      fetchRegionOptions().then(response => {
        if (response.data && response.data.code === 0 && response.data.data) {
          response.data.data.forEach(x => {
            this.areaOptions.push({ label: x.regionName, value: x.regionName });
          });
        }
      });
    },
    resetFilter() {
      Object.keys(this.filter).forEach(key => this.filter[key] = '');
      this.loadData(true);
    },
    loadMarketOptions() {
      fetchMarketOptions().then(response => {
        if (response.data && response.data.code === 0 && response.data.data) {
          response.data.data.forEach(x => {
            this.marketOptions.push({ label: x.organizationName, value: x.organizationId });
          });
        }
      });
    },
  }
}
</script>

<style lang="scss" scoped>
.activity-list-filter {
  display: none; // 现阶段不需要filter条件
  margin: 0 10px;
  &-value {
    width: 96% !important;
  }
  &-reset {
    float: right;
    margin-right: 8px;
  }
  &-search {
    float: right;
    margin-right: 10px;
    border-color: #5383f3;
    color: #5383f3;
  }
}
</style>